<quill-editor format="html" [(ngModel)]="model[bindingProperty]" name="quilleditor"></quill-editor>